import type { Identity } from '../api/client';
import type { RuntimeConfig } from '../auth/oauth';
import { signOut } from '../auth/session';
import { navigate } from '../router';

export function SessionBar({
  identity,
  config,
  onSignedOut,
}: {
  identity: Identity;
  config: RuntimeConfig;
  onSignedOut: () => void;
}) {
  return (
    <header className="sessionbar">
      <a
        className="brand"
        href="/"
        onClick={(e) => {
          e.preventDefault();
          navigate('/');
        }}
      >
        Identity broker admin
      </a>
      <div className="session">
        <span className="muted">{identity.email}</span>
        <button
          type="button"
          onClick={() => {
            void signOut(config).then((outcome) => {
              onSignedOut();
              // On 'redirecting' the browser is already on its way to Cognito, which returns it to
              // /signed-out itself. Navigating here as well would race that redirect and could
              // cancel it, leaving the session cookie in place - the exact thing sign-out is for.
              if (outcome === 'local') navigate('/signed-out');
            });
          }}
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
